import axios from 'axios';
import { getToken } from '../token';
import { API_CALL_ERROR, PRODUCTS_ENDPOINT } from './APIConstants';

export async function getProducts() {
  try {
    const { data } = await axios.get(PRODUCTS_ENDPOINT, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function getProductsByCategoryId(categoryId) {
  try {
    const { data } = await axios.get(PRODUCTS_ENDPOINT, {
      params: {
        categoryId: categoryId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}

export async function getProductsBySearch(search) {
  try {
    const { data } = await axios.get(PRODUCTS_ENDPOINT, {
      params: {
        search: search,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}
